import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import NewsletterFormAlt from '@components/shared/NewsletterFormAlt';
import { BodyLG, BodySM } from '@components/shared/TextTypes';
import TwoColumn from '@components/shared/TwoColumn';
import { VMS_FOUNDERS_RESULTS_IMG } from '@constants';

const NewsletterCBDSubscribe = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Inner>
        <TwoColumn gap="60px" mobileReverse={true} breakpoint="1024px" alignment="center">
          <TextWrap>
            <Title>Want to know more?</Title>
            <StyledBodyLG>Sign up to our newsletter to learn more about our CBD-infused products.</StyledBodyLG>
            <NewsletterFormAlt textColor={Colors.forestGreen} buttonText={t('components.submit')} />
            <StyledBodySM>{t('components.vms-founders-results.note')}</StyledBodySM>
          </TextWrap>
          <StyledImg src={VMS_FOUNDERS_RESULTS_IMG} alt="VMS Founders Results" />
        </TwoColumn>
      </Inner>
    </Container>
  );
};

export default NewsletterCBDSubscribe;

const Container = styled.div`
  background: ${Colors.mint}50;

  @media (max-width: 1024px) {
    padding: 0 30px 30px;
  }
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 20px;
  max-width: 420px;
  color: ${Colors.forestGreen};

  @media (max-width: 1024px) {
    align-items: center;
  }
`;

const Title = styled.h3`
  font-family: 'Domaine';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 120%;
  color: inherit;

  @media (max-width: 1024px) {
    text-align: center;
    font-size: 24px;
  }
`;

const StyledBodyLG = styled(BodyLG)`
  text-align: left;
  margin-bottom: 20px;
  color: inherit;

  @media (max-width: 1024px) {
    text-align: center;
    margin-bottom: 0px;
  }
`;

const StyledBodySM = styled(BodySM)`
  @media (max-width: 1024px) {
    text-align: center;
  }
`;

const StyledImg = styled.img`
  width: 100%;
  max-width: 482px;
  margin-top: 20px;

  @media (max-width: 1024px) {
    margin-bottom: 40px;
  }
`;
